import algoliasearch from 'algoliasearch/lite'

const client = algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID, process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_API_KEY)

const index = client.initIndex(process.env.NEXT_PUBLIC_ALGOLIA_INDEX)
const ads = client.initIndex(process.env.NEXT_PUBLIC_ALGOLIA_ADS_INDEX)

export default { index, ads }
